import { Toaster, toast } from "sonner"

export { toast }

export function ToastProvider({ children }: { children: React.ReactNode }) {
	return (
		<>
			{children}
			<Toaster
				position="bottom-center"
				toastOptions={{
					className: "!bg-bg-card !border-border-primary !text-text-primary",
					descriptionClassName: "!text-text-muted",
				}}
				visibleToasts={3}
			/>
		</>
	)
}

// Legacy hook for backwards compatibility during migration
export function useToast() {
	return {
		showToast: (message: string, type: "success" | "error" | "warning" | "info" = "info") => {
			switch (type) {
				case "success":
					toast.success(message)
					break
				case "error":
					toast.error(message)
					break
				case "warning":
					toast.warning(message)
					break
				default:
					toast.info(message)
					break
			}
		},
	}
}
